import { useFormikContext } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { getFieldErrorNames } from './utils/getFieldErrorNames'

export function useScrollToFieldError(noSmoothScroll?: boolean) {
  const { submitCount, isValid, errors, status, values } = useFormikContext()
  const [currentSubmitCount, setCurrentSubmitCount] = useState(0)

  const rForm = useRef({ isValid, errors })
  useEffect(() => {
    rForm.current = { isValid, errors }
  })

  const orderedFormKeys = useMemo(() => {
    return Object.keys(values as `Record<string, never>`)
  }, [values])

  useEffect(() => {
    if (
      rForm.current.isValid ||
      submitCount == 0 ||
      currentSubmitCount == submitCount
    )
      return

    setCurrentSubmitCount(submitCount)

    const fieldErrorNames = getFieldErrorNames(rForm.current.errors)

    if (fieldErrorNames.length <= 0) return

    const allInputs = document.querySelectorAll(
      'input,span[data-scroll],textarea',
    )

    const fieldErrorNamesDOMOrder: string[] = []

    allInputs.forEach((el) => {
      switch (el.nodeName.toLowerCase()) {
        case 'input': {
          const input = el as HTMLInputElement
          const nameInDotNotation = input.name
            .replace('[', '.')
            .replace(']', '')
          if (fieldErrorNames.indexOf(nameInDotNotation) >= 0) {
            fieldErrorNamesDOMOrder.push(input.name)
          }
          break
        }
        case 'span': {
          const span = el as HTMLElement
          const scrollName = span.getAttribute('data-scroll')
          if (scrollName && fieldErrorNames.indexOf(scrollName) >= 0) {
            fieldErrorNamesDOMOrder.push(scrollName)
          }
          break
        }
        case 'textarea': {
          const textarea = el as HTMLTextAreaElement
          const nameInDotNotation = textarea.name
            .replace('[', '.')
            .replace(']', '')
          if (fieldErrorNames.indexOf(nameInDotNotation) >= 0) {
            fieldErrorNamesDOMOrder.push(textarea.name)
          }
        }
      }
    })

    const fieldErrorNamesDOMOrderOrdered =
      noSmoothScroll || status == 'APIError'
        ? orderedFormKeys.filter((x) => fieldErrorNames.some((y) => x == y))
        : fieldErrorNamesDOMOrder

    const element: HTMLInputElement | null = document.querySelector(
      `input[name='${fieldErrorNamesDOMOrderOrdered[0]}'], span[data-scroll='${fieldErrorNamesDOMOrderOrdered[0]}'], textarea[name='${fieldErrorNamesDOMOrderOrdered[0]}']`,
    )

    if (!element) return

    // Scroll to first known error into view
    noSmoothScroll || status == 'APIError'
      ? element.scrollIntoView({ block: 'center' })
      : element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [
    submitCount,
    noSmoothScroll,
    status,
    orderedFormKeys,
    currentSubmitCount,
    errors,
  ])
}
